var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 343.02 51.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#3d3327;stroke-linecap:round;stroke-miterlimit:10;}.cls-1{stroke-width:14px;}.cls-2{stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "base"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.84,25S265.7-16.4,336,26.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7,26.55s51.68-39.14,120,6.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M196.44,14.39s-2.19,27.88,19.4,29.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.94,21.89s10,14.41,0,27.7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset2);
export default __webpack_public_path__ + "static/media/Asset 2.56e20c13.svg";
export { ForwardRef as ReactComponent };